import * as constants from '../constants/training_module'

const defaultState = {
  trainingModules: [],
  requestSuccess: false,
  requestType: '',
  excelBlob: null
}

export default (state = defaultState, action) => {
  var newState = {...state}

  switch (action.type){
    case constants.ARCHIVE_MODULES_REQUEST:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      return newState;
    case constants.ARCHIVE_MODULES_SUCCESS:
      newState.requestType = action.type;
      newState.trainingModules = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.ARCHIVE_MODULES_FAILURE:
      newState = defaultState;
      return newState;
    case constants.SHOW_ARCHIVED_REQUEST:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      return newState;
    case constants.SHOW_ARCHIVED_SUCCESS:
      newState.requestType = action.type;
      newState.trainingModules = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.SHOW_ARCHIVED_FAILURE:
      newState = defaultState;
      return newState;
    case constants.EXPORT_ARCHIVED_REQUEST:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      return newState;
    case constants.EXPORT_ARCHIVED_SUCCESS:
      newState.requestType = action.type;
      newState.excelBlob = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.EXPORT_ARCHIVED_FAILURE:
      newState = defaultState;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/training_module.js